// Import packages
import React from "react";

// Import components
import {InputGroup} from "./inputGroup";
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';

// Import styles
import "../../assets/styles/dataDisplay/staticTextRow.scss"
import { editIcon } from "../../assets/images";

export class StaticTextRow extends React.PureComponent {
    render() {
        const {
            label, editingField, name, value, tempValue, getTempValue, startEditing,
            saveStaticTexts, cancelEditing, inputType
        } = this.props;
        // console.log(editingField, 'editingField');
        return <div className="static-input-row">
            <label>{label}</label>
            <div className="flex-row">
                {name === "director-greetings-text"  ? <>
                        {editingField === name ?
                            <InputGroup inputType={inputType}
                                        name={name}
                                        maxLength={inputType === 'textarea' ? 10000 : 300}
                                        autoFocus={true}
                                        value={tempValue}
                                        onChange={getTempValue}/> :
                            <pre className="text-area-view">{value}</pre>}
                    </>
                    : <>
                        {editingField === name ?
                            <InputGroup inputType={inputType}
                                        type="text"
                                        name={name}
                                        maxLength={inputType === 'textarea' ? 10000 : 300}
                                        autoFocus={true}
                                        value={tempValue}
                                        onChange={getTempValue}/> :
                            <span className="input-view">{value}</span>}
                    </>}

                {<div className="action-buttons">
                    {editingField !== name ?
                        <button className="editing-btn"
                                onClick={() => startEditing(name)}>
                            <img src={editIcon} alt="edit"/>
                        </button> :
                        <>
                            <button className="saving-btn"
                                    onClick={saveStaticTexts}>
                                <SaveOutlined />
                            </button>
                            <button className="canceling-btn"
                                    onClick={cancelEditing}>
                                <CloseOutlined />
                            </button>
                        </>}
                </div>}
            </div>
        </div>
    }
}
